import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const SocialMediaTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M18.25 7.522a3.47 3.47 0 001.457-1.933 6.416 6.416 0 01-2.105.848 3.226 3.226 0 00-2.418-1.104c-1.83 0-3.313 1.565-3.313 3.495 0 .274.027.541.084.796-2.753-.146-5.195-1.536-6.83-3.652a3.627 3.627 0 00-.449 1.758c0 1.212.585 2.282 1.474 2.91a3.191 3.191 0 01-1.501-.437v.043c0 1.694 1.141 3.107 2.66 3.427-.28.082-.572.123-.875.123-.213 0-.422-.02-.623-.062.421 1.388 1.645 2.4 3.096 2.427A6.434 6.434 0 014 17.609a9.038 9.038 0 005.08 1.57c6.097 0 9.429-5.326 9.429-9.945 0-.152-.002-.303-.009-.452a6.926 6.926 0 001.654-1.81 6.36 6.36 0 01-1.903.55z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)
